import { render } from "./DeletePoke.vue?vue&type=template&id=5c434d5e&scoped=true"
import script from "./DeletePoke.vue?vue&type=script&lang=js"
export * from "./DeletePoke.vue?vue&type=script&lang=js"

import "./DeletePoke.vue?vue&type=style&index=0&id=5c434d5e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c434d5e"

export default script